export enum ModalDialogEvents {
    ACCEPTED= 'ACCEPTED',
    CLOSED = 'CLOSED',
    DECLINED = 'DECLINED'
}
